/**
 * Method to persist previoulsy selected language in nextItem
 * - Takes launch config of completed item as first param
 * - Takes next item id as second param
 * - Takes current task id as third param
 */

import { Language } from '../../common/interfaces/language';
import { createLaunchConfig } from '../../common/utils/launchConfig';
import { SessionStore } from '../../constants/sessionStore';
import { AssessmentDetails } from '../interfaces';

export const persistPreviouslySelectedLanguage = (
  launchConfigOfCompletedItemOfCurrentTask: string,
  nextItemId: string,
  currentTaskId: number,
  assessmentDetails: AssessmentDetails,
): string => {
  // Parsed the launchConfig of complted item of current task
  const parsedLaunchConfigOfCompletedItemOfCurrentTask = JSON.parse(launchConfigOfCompletedItemOfCurrentTask);

  // Normalize for createLaunchConfig
  let language: Language = {
    testId: assessmentDetails.defaultPackageLanguage.testId,
    activeComponentId: assessmentDetails.defaultPackageLanguage.activeComponentId,
    ...assessmentDetails.defaultPackageLanguage.language,
  };

  const { availableLanguages } = assessmentDetails;
  /**
   * Checking of language in the nextItem available lang will
   * be done here. If language is not available in available languages
   * then pass default language below in the createLaunchConfig method.
   */
  let counter = 0;
  while (counter < availableLanguages.length) {
    if (availableLanguages[counter].isoCode === parsedLaunchConfigOfCompletedItemOfCurrentTask.selectedLanguageCode) {
      language = availableLanguages[counter];
      break;
    }
    counter++;
  }

  // Create launch config and pass previously selected language
  const launchConfig = JSON.stringify(createLaunchConfig(nextItemId, currentTaskId, language, assessmentDetails));

  // Update the launch config in the session storage
  sessionStorage.setItem(SessionStore.launchconfig, launchConfig);

  return launchConfig;
};
